import React from 'react';
import {calcDiscountPrice, currencySymbol, getMediaURL, price} from "../../../../../config/values";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {Card, CardContent, Chip, Typography} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";
import {Link} from "react-router-dom";
import {Hourglass, Star, Store, Utensils, Package} from "lucide-react";
import AddToCartBtn from "./AddToCartIconBtn";
import {useTranslation} from "react-i18next";
import SubTitle from "../../../../components/elements/SubTitle";

function SingleCardProduct({product,classes,addtocart}) {
    const { t } = useTranslation();
    return (
        <Card component={Link} to={`/vendor/${product.shop?.slug}`} className={classes.SingleCardProduct}>
            <div className="media-holder media-wide">
                <img loading="lazy" src={getMediaURL(product.thumbnail,'square')} alt={product.name}/>
                {
                    !!product.discount_percent &&
                    <span className="discount_percent">{product.discount_percent}%</span>
                }
            </div>
            <CardContent className="card-content media-wide wfull">
                <div>
                    <SubTitle component="span" align="left" className="product-title-home">{product.name}</SubTitle>
                    {
                        !!product.average_rate &&
                        <span className='rating-holder'><Star className="rating-icon"/> {product.average_rate}</span>

                    }

                    <Typography component={Link} to={`/vendor/${product.shop?.slug}`} className='product-card-info vendor'><Store className="lucide-small-narrow lucide-icon-gray"/> {product.shop?.name}</Typography>
                    <Typography component="span" className='product-card-info'><Package className="lucide-small-narrow lucide-icon-gray"/> {product.inventory} {t('remains')}</Typography>

                </div>

                <div className='prd-card-footer'>
                    <Typography className="pricing">
                        {
                            !!product.discount_percent  ?
                                <>
                                    <del>{price(product.price)} {currencySymbol}</del>
                                    <strong>{price(calcDiscountPrice(product.price,product.discount_percent))} {currencySymbol}</strong>
                                </>
                                :
                                <strong>{price(product.price)} {currencySymbol}</strong>
                        }
                    </Typography>
                </div>

            </CardContent>
        </Card>
    );
}

export default withStyles(Styles)(SingleCardProduct);
